import { Construction } from "lucide-react";

export default function Scaffold({ title, note, testId }) {
  return (
    <div data-testid={testId}>
      <h1 className="mb-1 text-2xl font-bold text-slate-900">{title}</h1>
      <p className="mb-8 text-sm text-slate-500">{note}</p>
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-slate-300 bg-white py-20 text-center text-slate-400">
        <Construction className="h-10 w-10" />
        <p className="text-sm">This module is scaffolded and secured. Management UI will be enabled in an upcoming phase.</p>
      </div>
    </div>
  );
}
